import { create } from "zustand";

type State = {
  featureFlagsLoaded: boolean;
  tradeSettingsSidebarAndCog: boolean;
  // LQC-658 — RP "Request Information" buttons in the Trade Settings slide-in.
  // Flip to false to remove every button that calls the request endpoint.
  rpRequestInformationButtons: boolean;
  // LQC-1937 - re-enables Iceberg (releaseSize) for Order-type trades. Backend
  // feature name: "IcebergForOrdersFeature". Off = LQC-1088 behaviour
  // (iceberg locked at 100% for Orders).
  icebergForOrders: boolean;
  // LQC-2170 - the Expiry settings columns always show (GTC selected by
  // default); these flags enable the Day and Time options (off = visible but
  // disabled). Backend feature names: "ExpiryTypeDayFeature" /
  // "ExpiryTypeTimeFeature".
  expiryTypeDay: boolean;
  expiryTypeTime: boolean;
  // LQC-2171/2172/2173 - trade expiry, gated in three independent layers so the
  // riskier parts can be pulled without losing the safe ones. Backend feature
  // names: "TradeExpiryColumnFeature" / "TradeExpiryEditFeature" /
  // "TradeExpiryCountdownFeature". See docs/features/TRADE_EXPIRY.md.
  //   Column     - the "Expires" column (expiryEnd) exists at all.
  //   Edit       - the OP's pencil and edit-expiry popover (mock endpoint).
  //   Countdown  - the live tick, urgency tint, app clock and reconcile sweep.
  //                Off falls back to a static timestamp.
  tradeExpiryColumn: boolean;
  tradeExpiryEdit: boolean;
  tradeExpiryCountdown: boolean;
  // LQC-2576 - RP "Off-load Risk" right-click item on affirmed trades. Backend
  // feature name: "OffloadRiskFeature".
  offloadRisk: boolean;
  // LQC-2941 - Trade Creation leg entry: "+" button, draft leg rows and the right-click
  // Security Details panel. Backend feature name: "TradeCreationLegsFeature".
  tradeCreationLegs: boolean;
  // LQC-3027 - FRONT-END ONLY (not from /Settings/Features): the Edit pencil on saved
  // Unassigned Bond / Future blocks in Trade Creation. Set the default below to turn it on.
  tradeCreationEditBlocks: boolean;
};

type Action = {
  setFeatureFlags: (flags: Partial<State>) => void;
};

const featureFlagStore = create<State & Action>((set) => ({
  featureFlagsLoaded: false,
  tradeSettingsSidebarAndCog: false,
  rpRequestInformationButtons: false,
  icebergForOrders: false,
  expiryTypeDay: false,
  expiryTypeTime: false,
  tradeExpiryColumn: false,
  tradeExpiryEdit: false,
  tradeExpiryCountdown: false,
  offloadRisk: false,
  tradeCreationLegs: false,
  tradeCreationEditBlocks: true, //
  setFeatureFlags: (flags) => set(flags),
}));

export default featureFlagStore;
